module.exports = __webpack_public_path__ + "static/media/ic-arrow-down.3cb281d4.svg";